var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{attrs:{"mt-4":"","main-section":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-flex',{attrs:{"mt-3":""}},[_c('OvationsPoints')],1),(
          _vm.$store.getters.userIsAdministrativeOrOrgOwner &&
          !_vm.$store.getters.isCurrentOrgChild
        )?_c('v-flex',{attrs:{"mt-3":""}},[_c('BalanceBlock',{attrs:{"config":{
            floatBgColor: _vm.$store.state.colorScheme.funds.gOvations.base,
            floatTextColor: _vm.$store.state.colorScheme.funds.gOvations.accent,
            floatIcon: 'mdi-coins',
            balanceName: 'Distribute Ovations',
            balanceAmount: _vm.$store.state.userSelf.currentOrg.root,
            actionIcon: 'mdi-coins',
            actionText: 'DISTRIBUTE',
            actionTextZeroBalance: 'NO OVATIONS TO DISTRIBUTE',
            actionLink: '/assignovations',
            target: '',
            actionZeroBalanceLink: '/buyovations',
            btnClass: 'red-btn',
            textClass: 'display-1 red-text font-weight-bold',
            inAppLink: true,
            btnColor: '#d13b55',
          }}})],1):_vm._e(),_c('v-flex',{attrs:{"mt-3":""}},[_c('BalanceBlock',{attrs:{"config":{
            floatBgColor: _vm.$store.state.colorScheme.funds.dollars.base,
            floatTextColor: _vm.$store.state.colorScheme.funds.dollars.accent,
            floatIcon: 'mdi-coins',
            balanceName: 'Send Ovations',
            balanceAmount: _vm.$store.state.userSelf.currentOrg.giveOvations,
            actionIcon: 'mdi-coins',
            actionText: 'SEND',
            actionTextZeroBalance: 'NO OVATIONS TO SEND',
            actionLink: '/giveovations',
            target: '',
            actionZeroBalanceLink: '/dashboard',
            btnClass: 'blue-btn',
            textClass: 'display-1 blue-text font-weight-bold',
            inAppLink: true,
            btnColor: '#3cc0c9',
          }}})],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }